import { CoreApiResponse } from "../../libs/core-api-requests/common";
import { IInvoiceUpdateDTO, IInvoiceCorrectSum, IInvoiceCreateDTO, IInvoiceGetDTO, IInvoiceViewDTO, IDepositedChequeResponse } from "../../libs/coreapi-dto/documents/invoice";
import { ICreateDocumentFromItemsRequest, IInvoiceItemGetDTO, IInvoiceItemViewDTO } from "../../libs/coreapi-dto/documents/invoiceItem";
import CoreApiService from "../../system/api/coreApiService";
import { DocumentDataProviderV2 } from "./Common/DocumentDataProviderV2";
import { GtinListInfoDto } from "../../@types/kiz";
import { ICreateDocumentsResponse } from "../../libs/coreapi-dto/accounting/lot";


export class InvoiceDataProvider extends DocumentDataProviderV2<IInvoiceViewDTO, IInvoiceGetDTO, IInvoiceCreateDTO, IInvoiceUpdateDTO, IInvoiceItemViewDTO, IInvoiceItemGetDTO> {

    private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService;
    }

    getDataRequest(): Promise<IDocumentRequestV2<IInvoiceViewDTO, IInvoiceGetDTO, IInvoiceCreateDTO, IInvoiceUpdateDTO, IInvoiceItemViewDTO, IInvoiceItemGetDTO>> {
        return this._coreApiService.invoiceRequest;
    }

    getDataRequest2(): Promise<IInvoiceRequestV2<IInvoiceViewDTO, IInvoiceGetDTO, IInvoiceCreateDTO, IInvoiceUpdateDTO, IInvoiceItemViewDTO, IInvoiceItemGetDTO>> {
        return this._coreApiService.invoiceRequest;
    }

    getDataRequestExtra(): Promise<IInvoiceExtraRequestV2<IInvoiceViewDTO, IInvoiceGetDTO, IInvoiceCreateDTO, IInvoiceUpdateDTO, IInvoiceItemViewDTO, IInvoiceItemGetDTO>> {
        return this._coreApiService.invoiceRequest;
    }

    updateEditKizs(idDocumentGlobal: string, idDocumentItemGlobal: string, body: IInvoiceUpdateDTO, callback: () => void) { //e: CoreApiResponse<null>
        this.getDataRequest2()
            .then(r =>
                r.updateEditKizs(idDocumentGlobal, idDocumentItemGlobal, body, (e) => {
                    if (e.respType === 'isCompleted')
                        try {
                            callback?.(); //e.data
                        } catch {
                            console.error('ee')
                        }
                    else
                        throw new Error(e.message.text);
                })
            );
    }

    correctSum(idDocumentGlobal: string, body: IInvoiceCorrectSum, callback: (e: CoreApiResponse<null>) => void) { //e: CoreApiResponse<null>
        this.getDataRequestExtra()
            .then(r =>
                r.correctSum(idDocumentGlobal, body, (e) => {
                    if (e.respType === 'isCompleted')
                        try {
                            callback?.(e); //e.data
                        } catch {
                            console.error('ee')
                        }
                    else
                        throw new Error(e.message.text);
                })
            );
    }

    getViewProc(body: IViewBody, callback?: (data: IInvoiceViewDTO[], totalCount: number) => void) {
        this.getDataRequestExtra().then((r) =>
            r.getViewProc(body, (e) => {
                if (e.respType === "isCompleted") callback?.(e.data.entities, e.data.totalCount);
                else throw new Error(e.message.text);
            })
        );
    }

    createDepositedCheque(idDocumentGlobal: string, callback?: (response: IDepositedChequeResponse) => void, testApi?: ({ name, time }) => void, callbackFailed?: (e)=>void) {
        this.getDataRequestExtra().then((r) =>
            r.createDepositedCheque(idDocumentGlobal, (e, test) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data);
                    testApi?.(test as { name; time });
                } else {
                    callbackFailed?.(e)
                    throw new Error(e.message.text);
                }
            })
        );
    }

    сreateDocumentFromItems(request: ICreateDocumentFromItemsRequest, callback?: (response: ICreateDocumentsResponse) => void, testApi?: ({ name, time }) => void, callbackFailed?: (e)=>void) {
        this.getDataRequestExtra().then((r) =>
            r.сreateDocumentFromItems(request, (e) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data);
                } else {
                    callbackFailed?.(e)
                    throw new Error(e.message.text);
                }
            })
        );
    }

    repeatInfoGismtEnabled(idDocumentGlobal: string, callback?: (result: boolean) => void) {
        this._coreApiService.invoiceRequest.then((r) => r.repeatInfoGismtEnabled(idDocumentGlobal, (e) => {
            if (e.respType === "isCompleted") callback?.(e.data)
                else callback?.(false);
        }))
    }
	
   checkSgtins(idDocumentGlobal: string, callback?: (response: any) => void, callbackFailed?: (e) => void) {
        this._coreApiService.kizRequest.then((r) => 
            r.checkSgtins(idDocumentGlobal, (e) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data);
                } else {
                    callbackFailed?.(e);
                }
            })
        );
    }

    getCheckSgtinsResult(taskId: string, idDocumentGlobal: string, callback?: (response: GtinListInfoDto) => void, callbackFailed?: (e) => void) {
    this._coreApiService.kizRequest.then((r) => 
        r.getCheckSgtinsResult(taskId, idDocumentGlobal, (e) => {
            if (e.respType === "isCompleted") {
                callback?.(e.data);
            } else {
                callbackFailed?.(e);
            }
        })
    );
    }

    removeInvalidKizs(idDocumentGlobal: string, body: { invalidSgtins: string[] }, callback?: () => void, callbackFailed?: (e) => void) {
    this._coreApiService.kizRequest.then((r) => 
        r.removeInvalidKizs(idDocumentGlobal, body, (e) => {
            if (e.respType === "isCompleted") {
                callback?.();
            } else {
                callbackFailed?.(e);
            }
        })
    );
    }

    logIgnoreCheck(idDocumentGlobal: string, callback?: () => void, callbackFailed?: (e) => void) {    
    this._coreApiService.kizRequest.then((r) => {
        
        if (typeof r.logIgnoreCheck !== 'function') {
            console.error("r.logIgnoreCheck is NOT a function!");
            callbackFailed?.(new Error("logIgnoreCheck method not found"));
            return;
        }
        
        console.log("calling r.logIgnoreCheck");
        r.logIgnoreCheck(idDocumentGlobal, (e) => {
            if (e.respType === "isCompleted") {
                callback?.();
            } else {
                callbackFailed?.(e);
            }
        });
    }).catch((error) => {
        console.error("kizRequest promise rejected:", error);
        callbackFailed?.(error);
    });
}
}